import styled from 'styled-components';

const PageContainer = styled.div`
  padding: 1em;
  * {
    box-sizing: border-box;
  }
`;

export default PageContainer;
